import type { FC } from "react";
import { ToastContainer } from "react-toastify";
import { AppRouter } from "./router/AppRouter";
import "react-toastify/dist/ReactToastify.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AppContext } from "./context/AppContext";
import { queryClient } from "./queries/queryClient";

export const FastAdmin: FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <AppContext>
        <AppRouter />
      </AppContext>
      {process.env.NODE_ENV === "development" && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
};
